// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","controls":"App_controls__14oJX","right":"App_right__1pmkn"};